import CustomTooltip from '../../../../components/CustomTooltip';
import { FileTracking, IconEquipment } from '../../../../components/buttons/IconButtons';
import CustomModal from '../../../../components/Modal/CustomModal';
import CustomCard from '../../../../components/CustomCard';
import CustomChip from '../../../../components/CustomChip';
import { statusBorderColor, statusColor, statusFontColor } from '../../../../enums/statusColorEnum';
import { status } from '../../../../enums/statusEnum';
import Tracking from '../SubComponents/Tracking';
import EquipmentMaterialModalApp from '../Functionality/EquipmentMaterialModalApp';
import { EMPTY_VALUES } from '../../../../Apis/functions';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const EquipmentMaterialModal = (props) => {
    const { item, markAsCompleted, onClose, setShowMarkAsReadModal } = props;
    const {
        subView,
        handleSubViewChange,
        t,
        moduleId,
        criteria,
        search,
        option,
        setCriteria,
        displayModal,
        setDisplayModal,
        equipment
    } = EquipmentMaterialModalApp({item});

    return (
        <CustomModal
            {...props}
            size='lg'
            buttonConfirm='confirm'
            confirmButton={false}
            cancelButton={false}
            classNameBody='m-0 p-0'
            display={displayModal}
            topLeftHeader={
                <>
                    <div className='d-flex align-items-center'>
                        <FileTracking width={32} height={32} />
                        <div className={'flex-grow-1 minw-0 '}>
                            <CustomTooltip
                                text={t('tracking')}
                                classes={'font-color-general-950 ibl-font-w-600 fs-24px text-ellipsis-1-row ml-2'}
                                showIfTruncated={true}
                                placement={'top'}
                            />
                        </div>
                    </div>
                </>
            }
        >
            <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                <div className='d-flex align-items-center justify-content-between mx-2'>
                    <div className='d-flex align-items-center'>
                        <IconEquipment className='w-32px h-32px' />
                        <p className='fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row mb-3 mt-3 ml-3'>
                            {item?.name}
                        </p>
                    </div>
                    <CustomChip
                        variant='large'
                        background={statusColor[item?.statusId]}
                        fontColor={statusFontColor[item?.statusId]}
                        borderColor={statusBorderColor[item?.statusId]}
                        legend={t(status[item?.statusId]) || EMPTY_VALUES.DEFAULT}
                    />
                </div>
                <div className={'border-bottom-shades-300'} />
                <Tracking
                    subView={subView}
                    handleSubViewChange={handleSubViewChange}
                    t={t}
                    moduleId={moduleId}
                    criteria={criteria}
                    search={search}
                    option={option}
                    setCriteria={setCriteria}
                    materialId={item.id}
                    markAsCompleted={markAsCompleted}
                    onHide={onClose}
                    setShowMarkAsReadModal={setShowMarkAsReadModal}
                    setDisplayModal={setDisplayModal}
                    equipment={equipment}
                />
            </CustomCard>
        </CustomModal>
    );
};

export default EquipmentMaterialModal;
